import React from 'react'
import { Link } from 'react-router-dom'

import { FieldMeta } from '../fieldMeta/FieldMeta'

import style from './FieldInput.module.scss'
import { FieldInputProps } from './FiledInput.types'

export function FieldInput({
  value,
  label,
  error,
  onChange,
  placeHolder,
  handleBlur,
  name,
  disabled,
  addonLabel,
  addonLabelText,
  addonLabelLink,
  type,
  touched,
  readOnly,
  errorMessage
}: FieldInputProps) {
  const errorMsg = touched && error ? error : undefined

  return (
    <div className={style.field}>
      <label className={style.fieldLabel} htmlFor={name}>
        {label}
        <span>
          {addonLabel && addonLabelLink && (
            <Link to={addonLabelLink}>
              <span className={style.addonLabelClassname}>{addonLabelText}</span>
            </Link>
          )}
        </span>
      </label>
      <input
        readOnly={readOnly}
        id={label}
        type={type || 'text'}
        disabled={disabled}
        name={name}
        value={value ?? undefined}
        placeholder={placeHolder}
        onBlur={handleBlur}
        onChange={e => onChange?.(e.target.value)}
        data-testid={name}
        className={errorMsg || errorMessage ? style.fieldInput : undefined}
      />
      <FieldMeta error={errorMsg} />
    </div>
  )
}
